'use client';
import * as React from 'react';
import { AnalyticsContext } from '../context';

export interface SmartLinkProps
  extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  action?: string;
  category?: string;
  dofollow?: boolean;
  label?: string;
  object?: any;
  onClick?: (object?: any) => void;
  preventDefaultOnClick?: boolean;
  target?: React.HTMLAttributeAnchorTarget;
  trackClickEvent?: (object?: any) => void;
}

export const SmartLink: React.FC<SmartLinkProps> = ({
  action,
  category,
  children,
  className,
  dofollow,
  href,
  label,
  object,
  onClick,
  preventDefaultOnClick = true,
  target = '_blank',
  trackClickEvent,
  ...props
}: SmartLinkProps) => {
  const analytics = React.useContext(AnalyticsContext);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      if (onClick) {
        onClick(object);
        if (preventDefaultOnClick) {
          event.preventDefault();
        }
      }

      if (trackClickEvent) {
        trackClickEvent(object);
      }
    },
    [onClick, trackClickEvent, object, preventDefaultOnClick],
  );

  const isGoLink = href?.match('https://www.benzinga.com/go/') ? true : false;

  return (
    <a
      {...props}
      className={className}
      data-action={action}
      data-category={category}
      // data-label={label}
      data-label={analytics?.label ? `${analytics?.label}: ${label}` : label}
      href={href}
      onClick={handleClick}
      rel={`${isGoLink ? 'noopener sponsored' : ''} ${
        (dofollow !== false && !isGoLink) || dofollow === true ? 'dofollow' : 'nofollow'
      }`.trim()}
      target={target}
    >
      {children}
    </a>
  );
};
